import React, { useContext, useEffect, useRef } from 'react';
import {
  DetailContext,
  DetailHandle,
  DetailMode,
  EvidenceContext,
  UserContext,
} from '@eas/common-web';
import { DraftField } from '@composite/drafts/draft-field';
import { EsFile, Me } from '@models';
import { EvidenceApiUrl, Role, UIElement } from '@enums';
import { DRAFT_SOURCE } from '../../../es-file/es-file-hooked-sources';
import { useDisciplinaryProceedingsPermission } from '../../../es-file/es-file-permission';

export function DraftsFields() {
  const { hookedSources } = useContext(EvidenceContext);
  const { user } = useContext<UserContext<Me>>(UserContext);
  const { isLocked, mode, source } =
    useContext<DetailHandle<EsFile>>(DetailContext);

  const { hasPermission } = useDisciplinaryProceedingsPermission(source.data);
  const loadedDraftsFor = useRef<string>();
  const disabledDrafts =
    isLocked ||
    mode !== DetailMode.VIEW ||
    !hasPermission(
      UIElement.DisciplinaryProceedingsFile.DRAFTS,
      !!user?.userRoles.find((role) => role.role === Role.JUDGE) // skipAssignmentCheck for JUDGE
    );
  const draftSource = hookedSources[DRAFT_SOURCE]?.source;

  useEffect(() => {
    const id = source.data?.id;

    if (
      draftSource &&
      id &&
      (loadedDraftsFor.current !== id || !draftSource.isDataValid())
    ) {
      loadedDraftsFor.current = id;
      draftSource.setUrl(`${EvidenceApiUrl.ES_FILES}/${id}/draft/list`);
      draftSource.reset();
      draftSource.loadMore();
    }
  }, [draftSource, source.data?.id]);

  return (
    <>
      <DraftField disabled={disabledDrafts} source={draftSource} />
    </>
  );
}
